import { BaseSportsSubscriber } from "../baseSportsSubscriber";
import { sportsbookConnectionHOF } from "../../sportsbookConnectionHOF";
export class SportsEmptySubscriber extends BaseSportsSubscriber {
    constructor(onErrorCallback) {
        super(() => undefined, onErrorCallback);
        this.query = {
            name: "subscribe",
            params: {}
        };
    }
}
export const SportsEmptySubscriberHOF = sportsbookConnectionHOF(SportsEmptySubscriber, {}, true);
//# sourceMappingURL=SportsEmptySubscriber.js.map